import { Component, inject } from "@angular/core";

import { MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface PasswordExpirationDialogData
{
    readonly expirationMessage: string;
}

@Component({
    selector: "password-expiration-dialog-component",
    templateUrl: "./passwordExpirationDialog.tmpl.html",
    styleUrls: [
        "./passwordExpirationDialog.component.scss"
    ],
    standalone: false
})
export class PasswordExpirationDialogComponent
{
    private readonly data = inject<PasswordExpirationDialogData>(MAT_DIALOG_DATA);


    get expirationMessage(): string
    {
        return this.data.expirationMessage;
    }
}
